import React, { useState } from "react";
import "../css/common.scss";
import logo from "../img/jst-logo.png";

const OptionsSwitch = ({ selectedOption, onModeChange }) => {
  const handleClick = (option) => {
    if (onModeChange) {
      onModeChange(option); // Notify the parent component of the change
    }
  };

  const styles = {
    container: {
      display: "flex",
      alignItems: "center",
    },
    option: {
      cursor: "pointer",
      padding: "1rem",
      fontSize: "15px",
      position: "relative",
      transition: "color 0.3s",
      flex:"1",
      textAlign: "center",
    },
    active: {
      fontWeight: "bold",
      color: "#d7172f",
      borderColor:"#d7172f",
    },
    // underline: {
    //   position: "absolute",
    //   bottom: "0",
    //   left: "0",
    //   width: "100%",
    //   height: "2px",
    //   backgroundColor: "#d7172f",
    // },
  };

  return (
    <div className="optionswitch" style={styles.container}>
      <div className="card-header"
        style={{
          ...styles.option,
          ...(selectedOption === "Scan" ? styles.active : {}),
        }}
        onClick={() => handleClick("Scan")}
      >
        Scan
        {selectedOption === "Scan" && <div style={styles.underline}></div>}
      </div>
      <div className="card-header"
        style={{
          ...styles.option,
          ...(selectedOption === "Manual" ? styles.active : {}),
        }}
        onClick={() => handleClick("Manual")}
      >
        Manual
        {selectedOption === "Manual" && <div style={styles.underline}></div>}
      </div>
    </div>
  );
};


export default OptionsSwitch;
